export const TOOGLE_MODAL_QUICK_ACCESS = 'TOOGLE_MODAL_QUICK_ACCESS'
export const TOOGLE_MODAL_VERIFY_CODE = 'TOOGLE_MODAL_VERIFY_CODE'
